import React from 'react';
import MarkdownRenderer from '../common/MarkdownRenderer';
import { slugify, nodeToText } from './slugify';

// A thin wrapper around the shared MarkdownRenderer that overlays `id`
// attributes (Django-slugify of the heading text) onto h2/h3/h4 so the
// Library's TableOfContents jump-links resolve. We do NOT modify the shared
// renderer — we pass extra `components` overrides which react-markdown merges,
// taking precedence over the defaults for just these heading tags.
//
// We add `scroll-mt-24` so anchored headings aren't hidden under the fixed
// top bar when jumped to.
const headingOverrides = {
  h1: ({ children }) => (
    <h1
      id={slugify(nodeToText(children))}
      className="scroll-mt-24 text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mb-3 sm:mb-4 pb-2 border-b border-gray-200 dark:border-gray-700 break-words"
    >
      {children}
    </h1>
  ),
  h2: ({ children }) => (
    <h2
      id={slugify(nodeToText(children))}
      className="scroll-mt-24 text-lg sm:text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2 sm:mb-3 mt-4 sm:mt-6 break-words"
    >
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3
      id={slugify(nodeToText(children))}
      className="scroll-mt-24 text-base sm:text-lg font-medium text-gray-700 dark:text-gray-300 mb-2 mt-3 sm:mt-4 break-words"
    >
      {children}
    </h3>
  ),
  h4: ({ children }) => (
    <h4
      id={slugify(nodeToText(children))}
      className="scroll-mt-24 text-sm sm:text-base font-medium text-gray-700 dark:text-gray-300 mb-1.5 sm:mb-2 mt-2 sm:mt-3 break-words"
    >
      {children}
    </h4>
  ),
};

const LibraryMarkdown = ({ content, className = '' }) => (
  <MarkdownRenderer content={content} className={className} components={headingOverrides} />
);

export default LibraryMarkdown;
